import React from 'react';
import Icon from '../icon/icon';
import * as s from './styled-password-input';

const InputCadastroSenha = ({
  src,
  icon,
  placeholder,
  onChange,
  value,
  style,
  width,
  height,
  type,
  size,
  noPadding,
  focused,
  onClick,
  login,
  disabled,
  maxLength,
  hasEye,
  errorMessage,
}) => {
  const [showPassword, setShowPassword] = React.useState(false);

  return (
    <s.Container
      disabled={disabled}
      focused={focused}
      width={width}
      height={height}
      style={style}
      noPadding={noPadding}
      title={placeholder}
      login={login}
      errorMessage={errorMessage}
    >
      {icon ? (
        <s.IconWrapper>{icon}</s.IconWrapper>
      ) : (
        src && <s.Icon src={src} alt="icon" size={size} />
      )}
      <s.Input
        maxLength={maxLength}
        width={width}
        height={height}
        onClick={onClick}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        type={showPassword ? 'text' : type || 'text'}
        login={login}
      />
      {hasEye && (
        <s.EyeButton
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            setShowPassword((prev) => !prev);
          }}
        >
          <s.IconWrapper>
            <Icon name={showPassword ? 'eye' : 'eye-off'} size={20} />
          </s.IconWrapper>
        </s.EyeButton>
      )}
    </s.Container>
  );
};

export default InputCadastroSenha;
